import type { UpperArchSettings } from '@witmetrics/unison-core';
import Button from '@/components/Button';
import Divider from '@/components/Divider';
import SelectionControls from './SelectionControls';
import VeneerControls from './VeneerControls';
import type { FaceFilterSettings, SimulationStep } from '../types';
import { STEPS } from '../constants';
import { classes } from './utils';

export type ControlsHeaderProps = {
  activeStep: SimulationStep;
  archSettings: UpperArchSettings;
  opacity: number;
  filter: FaceFilterSettings;
  onUpdateFilter: (filter: FaceFilterSettings) => void;
  onSaveMask: () => void;
  onSave: () => void;
  onReset: () => void;
  onUpdateArchSettings: (settings: UpperArchSettings) => void;
  onUpdateOpacity: (opacity: number) => void;
};

export default function ControlsHeader({
  activeStep,
  archSettings,
  opacity,
  filter,
  onUpdateFilter,
  onSaveMask,
  onSave,
  onReset,
  onUpdateArchSettings,
  onUpdateOpacity,
}: ControlsHeaderProps) {
  const renderCanvasControls = () => {
    if (activeStep === STEPS.SELECT_MOUTH) {
      return <SelectionControls />;
    } else if (activeStep === STEPS.PLACE_TEETH) {
      return (
        <VeneerControls
          archSettings={archSettings}
          opacity={opacity}
          filter={filter}
          onChange={onUpdateArchSettings}
          onUpdateFilter={onUpdateFilter}
          onUpdateOpacity={onUpdateOpacity}
        />
      );
    }
    return null;
  };

  const renderStepControls = () => {
    if (activeStep === STEPS.SELECT_MOUTH) {
      return <Button onClick={() => onSaveMask()}>Next</Button>;
    }
    if (activeStep === STEPS.PLACE_TEETH) {
      return (
        <div className={classes.stepControls}>
          <Divider flexItem orientation="vertical" />
          <Button variant="ghost" onClick={() => onReset()}>
            Reset
          </Button>
          <Button onClick={() => onSave()}>Save</Button>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={classes.wrapper}>
      {renderCanvasControls()}
      {renderStepControls()}
    </div>
  );
}
